const keys = {
    firebase : {
        API_KEY : 'AIzaSyBwFXs33QRx7hDqZ_Z1jahE6VURj-lNN1g'
    }
}
export default keys;